var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    [
      _c("Categories", { attrs: { categoryId: _vm.$route.params.categoryId } }),
      _vm._v(" "),
      _vm.products ? _c("Products") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }